import type { StateWithSinatra } from '../types';

export const selectUser = (state: StateWithSinatra) => state.sinatra.user;

export const selectUserPermissions = (state: StateWithSinatra) =>
  state.sinatra.user?.currentRole?.permissions || [];
